import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { salesProceedsSchema } from './salesProceedsSchema';
import { GST_DEFAULT } from '@/constants/common';
import {
  COMPLETION_PERIOD,
  EXERCISE_PERIOD,
  BankPenaltyStatus,
  GstStatus,
  SalesTypes,
  OPTION_FEE,
  OPTION_EXERCISE_FEE,
} from '@/constants/commercial-industrial/sales-proceeds';
import * as calculatorConfig from '@/config/base-config.json';

export const initialState = {
  formField: {
    saleType: SalesTypes.Commercial as string,
    sellingPrice: 0,
    outstandingLoan: 0,
    optionFee: OPTION_FEE.DEFAULT,
    optionExerciseFee: OPTION_EXERCISE_FEE.DEFAULT,
    ssd: '0',
    legalFee: calculatorConfig.legal_fee,
    bankPenaltyIfAny: BankPenaltyStatus.NO,
    bankPenalty: '0',
    serviceCommissionPercent: 2.0,
    gstPercent: GST_DEFAULT,
    others: 0,
    hasGST: GstStatus.YES,
    otpDate: new Date().toString(),
    completionPeriod: COMPLETION_PERIOD.DEFAULT.toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT.toString(),
  },
  loading: true,
};

export const commercialIndustrialSalesProceeds = createSlice({
  name: 'ciSalesProceeds',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof salesProceedsSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = commercialIndustrialSalesProceeds.actions;

export default commercialIndustrialSalesProceeds.reducer;
